import { useState, useEffect, memo, ChangeEvent, FunctionComponent } from 'react';
import cn from 'classnames'
import { SliderProps } from './slider.interface'
import './slider.style.scss'

export const SliderComponent = (props: SliderProps) => {
  const {
    value,
    min = 0,
    step = 0,
    showText,
    onChange,
    className,
    max = 100,
    variant = 'plain',
    ...rest
  } = props
  const [minValue, setMinValue] = useState(value ? value.min : min)
  const [maxValue, setMaxValue] = useState(value ? value.max : max)

  useEffect(() => {
    if (value) {
      setMinValue(value.min)
      setMaxValue(value.max)
    }
  }, [value])

  const handleMinChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    const newMinVal = Math.min(+e.target.value, maxValue - step)
    if (!value) setMinValue(newMinVal)
    onChange?.({ min: newMinVal, max: maxValue })
  }

  const handleMaxChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    const newMaxVal = Math.max(+e.target.value, minValue + step)
    if (!value) setMaxValue(newMaxVal)
    onChange?.({ min: minValue, max: newMaxVal })
  }

  const minPos = ((minValue - min) / (max - min)) * 100
  const maxPos = ((maxValue - min) / (max - min)) * 100

  const classWrapper = cn(className, {
    'legion-slider': true,
    'legion-slider--show-text': showText,
    'legion-slider--show-text-box': showText && variant === 'box',
  })

  const classLabel = cn({
    'legion-slider__label': true,
    'legion-slider__label--box': variant === 'box',
  })

  return (
    <div {...rest} className={classWrapper}>
      <div className='legion-slider__inputs'>
        <input type='range' value={minValue} min={min} max={max} step={step} onChange={handleMinChange}/>
        <input type='range' value={maxValue} min={min} max={max} step={step} onChange={handleMaxChange}/>
      </div>

      <div className='legion-slider__control' aria-hidden='true'>
        <div className='legion-slider__bullet' style={{ left: `${minPos}%` }}/>

        {showText && (
          <span className={classLabel} style={{ left: `${minPos}%` }}>
            {minPos}%
          </span>
        )}

        <div className='legion-slider__rail'>
          <div className='legion-slider__rail__inner' style={{ left: `${minPos}%`, right: `${100 - maxPos}%` }}/>
        </div>

        <div className='legion-slider__bullet' style={{ left: `${maxPos}%` }}/>

        {showText && (
          <span className={classLabel} style={{ left: `${maxPos}%` }}>
            {maxPos}%
          </span>
        )}
      </div>
    </div>
  )
}

export const Slider = memo(SliderComponent as FunctionComponent<SliderProps>)
